import DialogActions from '@mui/material/DialogActions'
import Typography from '../../atoms/typography'
import { styled } from '@mui/system'

const shouldForwardProp = (prop) => {
	return !['dialogVariant'].includes(prop)
}

const Title = styled(Typography, {
	shouldForwardProp,
})`
	padding-bottom: ${({ dialogVariant }) => (dialogVariant === 'lg' ? '42px' : '32px')};
`
const Description = styled(Typography)``

const Actions = styled(DialogActions, {
	shouldForwardProp,
})`
	margin-top: ${({ dialogVariant }) => (dialogVariant === 'lg' ? '52px' : '40px')};
	flex-direction: column-reverse;
	${({ theme }) => theme.breakpoints.up('sm')} {
		flex-direction: row;
	}
`
export { Title, Description, Actions }
